import "./AppDrawer.scss";
import { getSlot, convertToUnit } from "@/core/util/helpers";
import simplebar from "simplebar-vue";

export default {
  components: {
    simplebar
  },
  data() {
    return {
      isActive: false,
      activatorNode: [],
      activatorElement: null
    };
  },

  props: {
    disabled: Boolean,
    right: Boolean,

    contentClass: {
      type: String,
      default: ""
    },
    width: {
      type: [String],
      required: false,
      default: "300"
    },
    disableEsc: Boolean,
    disableOutsideClick: Boolean
  },

  computed: {
    canShow() {
      return this.$app.breakpoint.smAndDown && !this.disabled;
    },

    body() {
      if (typeof document !== "undefined") {
        return document.querySelector("html");
      }
      return null;
    }
  },

  watch: {
    $route() {
      this.closeMenu();
    },

    canShow: {
      immediate: true,
      handler(after, before) {
        if (before && !after) {
          this.closeMenu();
        }
      }
    }
  },

  methods: {
    openMenu() {
      this.$emit("openMenu");
      if (this.body) this.body.classList.add("nav-drawer-open");
      this.isActive = true;
    },

    closeMenu() {
      this.$emit("closeMenu");
      if (this.body) this.body.classList.remove("nav-drawer-open");
      this.isActive = false;
    },

    closeMenuOnEsc(e) {
      e = e || window.event;
      if (e.key === "Escape" || e.keyCode === 27) {
        this.closeMenu();
      }
    },

    documentClick(e) {
      let activator = this.getActivator();
      let menu = this.$refs.menu;

      let target = null;
      if (e && e.target) {
        target = e.target;
      }

      if (
        activator &&
        activator !== target &&
        !activator.contains(target) &&
        menu &&
        menu !== target &&
        this.isActive &&
        !this.disableOutsideClick
      ) {
        this.closeMenu();
      }
    },

    getActivator() {
      if (this.activatorElement) return this.activatorElement;
      let activator = null;

      if (this.activatorNode.length) activator = this.activatorNode[0].elm;
      this.activatorElement = activator;
      return this.activatorElement;
    },

    genActivator() {
      const node =
        getSlot(this, "activator", {
          on: this.genActivatorListeners()
        }) || [];

      this.activatorNode = node;

      return node;
    },

    genActivatorListeners() {
      if (this.disabled) return {};

      const listeners = {};

      listeners.click = e => {
        e.stopPropagation();
        if (this.isActive) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      };

      return listeners;
    },

    genContent() {
      const content = this.$createElement(
        "simplebar",
        {
          staticClass: "nav-drawer__content",
          class: {
            [this.contentClass]: true
          },
          attrs: {
            "data-simplebar-auto-hide": "false"
          },
          ref: "content"
        },
        [
          this.$createElement(
            "div",
            {
              staticClass: "nav-drawer__content_wrap"
            },
            [getSlot(this, "default", false)]
          )
        ]
      );

      const overlay = this.$createElement("div", {
        staticClass: "nav-drawer__overlay",
        class: {
          "nav-drawer__overlay--is-open": this.isActive
        },
        on: {
          click: this.closeMenu
        },
        ref: "overlay"
      });
      const menu = this.$createElement(
        "div",
        {
          staticClass: "nav-drawer__menu",
          style: {
            width: convertToUnit(this.width)
          },
          class: {
            "nav-drawer__menu--left": !this.right,
            "nav-drawer__menu--right": this.right,
            "nav-drawer__menu--is-open": this.isActive
          },
          ref: "menu"
        },
        [content]
      );
      if (this.$app.breakpoint.smAndDown)
        return this.$createElement(
          "div",
          {
            staticClass: "nav-drawer__box",
            ref: "box"
          },
          [overlay, menu]
        );

      return null;
    }
  },

  render(h) {
    return h(
      "div",
      {
        staticClass: "nav-drawer"
      },
      [this.genActivator(), this.genContent()]
    );
  },

  beforeMount() {
    this.$nextTick(() => {
      if (this.activatorNode) {
        const activator = Array.isArray(this.activatorNode)
          ? this.activatorNode
          : [this.activatorNode];

        activator.forEach(node => {
          if (!node.elm) return;
          if (!this.$el.parentNode) return;

          const target =
            this.$el === this.$el.parentNode.firstChild
              ? this.$el
              : this.$el.nextSibling;

          this.$el.parentNode.insertBefore(node.elm, target);
        });
      }
    });
  },

  mounted() {
    if (this._isDestroyed || !this.$refs.content) return;

    let target = document.querySelector("[data-app]");

    if (!target) {
      console.log(`Unable to locate target [data-app]`);
      return;
    }

    target.insertBefore(this.$refs.box, target.firstChild);

    if (!this.disableEsc) {
      document.addEventListener("keyup", this.closeMenuOnEsc);
    }
  },

  beforeDestroy() {
    // IE11 Fix
    try {
      if (this.$refs.content && this.$refs.content.parentNode) {
        this.$refs.content.parentNode.removeChild(this.$refs.content);
      }

      if (this.activatorNode) {
        const activator = Array.isArray(this.activatorNode)
          ? this.activatorNode
          : [this.activatorNode];
        activator.forEach(node => {
          node.elm &&
            node.elm.parentNode &&
            node.elm.parentNode.removeChild(node.elm);
        });
      }
    } catch (e) {
      console.log(e);
    }
  },

  created: function() {
    document.addEventListener("click", this.documentClick);
  },

  destroyed: function() {
    document.removeEventListener("keyup", this.closeMenuOnEsc);
    document.removeEventListener("click", this.documentClick);
  }
};
